import React from 'react';
import iconMap, { NOT_AVAILABLE_ICON_CODE } from './IconMap.mjs';
import styled from 'styled-components';

const StyledIconWrapper = styled.div `
  display: inline-block;
  width: 32px;
  height: 32px;
`;
const WeatherIcon = ({ iconCode, size = 'regular', className }) => {
    var _a;
    const { icon: Icon, alt } = (_a = iconMap[Number(iconCode)]) !== null && _a !== void 0 ? _a : iconMap[NOT_AVAILABLE_ICON_CODE];
    return (React.createElement(StyledIconWrapper, { "aria-label": alt, className: className },
        React.createElement(Icon, { size: size, alt: alt })));
};

export { WeatherIcon as default };
//# sourceMappingURL=WeatherIconButton.mjs.map
